import { ModalPopup as Modal } from '@aon/aon-tws-common-ui/build/lib/components/Modal/Modal';
import * as React from 'react';
import styled from 'styled-components';
import contentConstants from '../../../contentConstants';
import { DistributionContactsListSourceType, IDistributionContactActionCreators, ISurveyParticipantActionCreators } from '../../../models';
import { IDistributionContactState } from '../../../store/DistributionContactStore';
import { ISurveyParticipantState } from '../../../store/SurveyParticipantStore';
import { DistributionContactsList } from './DistributionContactsList';

export type IDistributionContactProps = {
	surveyId: number;
	audienceId: number;
	readonly?: boolean;
	isOpen: boolean;
	onClose: () => void;
} & IDistributionContactState &
	ISurveyParticipantState &
	IDistributionContactActionCreators &
	ISurveyParticipantActionCreators;

const ModalPopup = styled(Modal)`
	.modal-content {
		min-height: 750px !important;
	}
`;
ModalPopup.displayName = 'ModalPopup';
const Content = styled.div`
	width: 100%;
`;
Content.displayName = 'Content';

export class DistributionContactsModal extends React.Component<IDistributionContactProps> {
	public render() {
		const { isOpen, readonly } = this.props;
		const modalTitle = readonly
			? contentConstants.DISTRIBUTION_CONTACTS_MODAL_TITLE_READONLY
			: contentConstants.DISTRIBUTION_CONTACTS_MODAL_TITLE;

		return (
			<ModalPopup
				isOpen={isOpen}
				title={modalTitle}
				onClosed={this.props.onClose}
				onSubmit={this.props.onClose}
				primaryButtonText={contentConstants.BUTTONS_CLOSE}
				contentfullwidth={true}
			>
				<Content>
					<DistributionContactsList
						{...this.props}
						distributionContactsListSourceType={DistributionContactsListSourceType.DistributionContactsModal}
					/>
				</Content>
			</ModalPopup>
		);
	}
}
